import i18n from '../i18n';

/**
 * Get the appropriate message from API response based on current language
 * @param {Object} response - API response object
 * @param {string} response.message - Default message
 * @param {string} response.message_en - English message (optional)
 * @param {string} response.message_es - Spanish message (optional)
 * @param {string} fallback - Fallback message if none found
 * @returns {string} - The appropriate message based on current language
 */
export const getApiMessage = (response, fallback = 'An error occurred') => {
    if (!response) return fallback;

    // Get current language from i18n
    const currentLang = i18n.language || 'en';

    // Check if language-specific message exists
    if (currentLang === 'es' && response.message_es) {
        return response.message_es;
    }

    if (currentLang === 'en' && response.message_en) {
        return response.message_en;
    }

    // Fallback to generic message if language-specific not available
    if (response.message) {
        return response.message;
    }

    return fallback;
};

/**
 * Show toast with appropriate language message
 * @param {Function} toastFn - Toast function (toast.error, toast.success, etc.)
 * @param {Object} response - API response object
 * @param {string} fallback - Fallback message if none found
 */
export const showToast = (toastFn, response, fallback) => {
    const message = getApiMessage(response, fallback);
    toastFn(message);
};
